/**
 * 稿件状态枚举
 */
export const ARTICLE_STATUS = {
  EDITING: 1, // 编辑中
  PENDING_AUDIT: 2, // 审核中
  REJECTED: 3, // 已驳回
  TO_PUBLISH: 4, // 待发布
  PUBLISHED: 5, // 已发布
  RETRY: 6, // 已撤稿
  DELETED: 7, // 已删除
};

/**
 * @typedef {typeof ARTICLE_STATUS[keyof typeof ARTICLE_STATUS]} ArticleStatus
 */

/**
 * @typedef {Object} ArticleStatusConfig
 * @property {string} label
 * @property {string} color
 * @property {string} [icon]
 */

/**
 * 状态配置（label / color / icon）
 * @type {Record<number, ArticleStatusConfig>}
 */
export const STATUS_CONFIG = {
  [ARTICLE_STATUS.EDITING]: { label: "编辑中", color: "#2196F3", icon: "edit" },
  [ARTICLE_STATUS.PENDING_AUDIT]: { label: "待审核", color: "#00BCD4" },
  [ARTICLE_STATUS.REJECTED]: { label: "已驳回", color: "#FF9800" },
  [ARTICLE_STATUS.TO_PUBLISH]: { label: "待发布", color: "#66BB6A" },
  [ARTICLE_STATUS.PUBLISHED]: { label: "已发布", color: "#009688" },
  [ARTICLE_STATUS.RETRY]: { label: "已撤稿", color: "#F44336" },
  [ARTICLE_STATUS.DELETED]: {
    label: "已删除",
    color: "#BF360C",
    icon: "delete",
  },
};

/**
 * 根据状态值获取展示配置。
 * @param {number|string|null|undefined} status 稿件状态
 * @returns {ArticleStatusConfig|undefined} 状态配置，未知状态返回 undefined
 */
export function getArticleStatusConfig(status) {
  const value = Number(status);
  if (!Number.isFinite(value)) return undefined;
  return STATUS_CONFIG[value];
}
